import { classNames } from "primereact/utils";

const message = {
    root: ({ props }) => ({
        className: classNames('inline-flex align-top', 'px-6 py-4 m-0 rounded-md', {
            'bg-faded-blue border-0 text-allstate-navy': props.severity == 'info',
            'bg-faded-green border-0': props.severity == 'success',
            'bg-faded-yellow border-0 ': props.severity == 'warn',
            'bg-faded-red border-0': props.severity == 'error'
        })
    }),
    icon: ({ props }) => ({
        className: classNames(
            'text-xl mr-2 hidden',
            {
                'text-warning-red': props.severity == 'error',
                'text-accent-green': props.severity == 'success',
                'text-allstate-blue': props.severity == 'info',
                'text-warning-yellow': props.severity == 'warn',
            }
        ),
    }),
}

export default message;
        